import React from 'react'
import { Grid, IconButton, Tooltip } from '@material-ui/core'
import { Delete as DeleteIcon, CheckCircle as CheckCircleIcon } from '@material-ui/icons'
import MaterialInputable from './MaterialInputable'
import MaterialSelectable from './MaterialSelectable'
import FormValidator from './FormValidator'
import PropTypes from 'prop-types'

class AccountNumbers extends React.Component {
	/**
	 * Default constructor object
	 * @param {props} props - the initial props object
	 * @returns {void} returns void
	 * @public
	 */
	constructor(props) {
		super(props)

		this.validator = this.getValidator(props)

		this.state = {
			validation: this.validator.valid()
		}

		this.onOtherTypeChange = this.onOtherTypeChange.bind(this)
		this.onOtherSupplierChange = this.onOtherSupplierChange.bind(this)
		this.onOtherAccountNumberChange = this.onOtherAccountNumberChange.bind(this)
		this.isValid = this.isValid.bind(this)
	}

	/**
	 * Performs validation of the data in the dialog.
	 * @returns {FormValidator} the current validation object
	 * @public
	 */
	getValidator() {
		return new FormValidator([
			{
				prop: {
					object: 'domain',
					name: 'otherType'
				},
				field: "otherType",
				method: 'isEmpty',
				validWhen: false,
				message: 'Type is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'otherSupplier'
				},
				field: "otherSupplier",
				method: 'isEmpty',
				validWhen: false,
				message: 'Supplier is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'otherAccountNumber'
				},
				field: "otherAccountNumber",
				method: 'isEmpty',
				validWhen: false,
				message: 'Account is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
		])
	}

	/**
	 * Update the validation object value for 'item'
	 * @param {string} item - the item in the validation object to update
	 * @param {boolean} isInvalid - the new state for isInvalid
	 * @param {string} message - the new message to be displayed
	 * @returns {void} returns void
	 * @public
	 */
	updateValidation(item, isInvalid = false, message = '') {
		let validation = Object.assign({}, this.state.validation)
		validation[item].isInvalid = isInvalid
		validation[item].message = message

		this.setState({
			validation: validation
		})

	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onOtherTypeChange(event) {
		this.updateValidation('otherType')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * The onChange event for the otherSupplier
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onOtherSupplierChange(event) {
		this.updateValidation('otherSupplier')

		if (this.props.onChange) {
			this.props.onChange(event)
		}
	}

	/**
	 * The onChange event for the otherAccountNumber
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onOtherAccountNumberChange(event) {
		this.updateValidation('otherAccountNumber')

		if (this.props.onChange) {
			this.props.onChange(event)
		}
	}

	/**
	 * Performs validation of the data in the dialog.
	 * @returns {boolean} is the current object valid?
	 * @public
	 */
	async isValid() {
		const validation = await this.validator.validate(this.state, this.props)
		this.setState({ validation })

		return validation.isValid
	}

	render() {
		const { index, disabled, domain, onRemove, accountTypes } = this.props
		const { validation } = this.state
		
		if (domain.isDelete) {
			return null
		}

		this.validator = this.getValidator()

		return (
			<React.Fragment>
				<Grid container spacing={1} style={domain.isCreate ? ((index % 2 === 1) ? { background: '#faf8cd' } : { background: '#fffee9' }) : (index % 2 === 1) ? { background: '#efefef' } : null}>
					<Grid item xs={3}>
						<MaterialSelectable 
							required
							name={index + "_otherType"} 
							label="Type" 
							value={domain.otherType}
							error={validation.otherType.isInvalid}
							errorMessage={validation.otherType.message}
							onChange={this.onOtherTypeChange} 
							options={accountTypes}
							disabled={disabled || domain.readOnly} />
					</Grid>
					<Grid item xs={3}>
						<MaterialInputable 
							required
							name={index + "_otherSupplier"} 
							label="Supplier"
							value={domain.otherSupplier} 
							error={validation.otherSupplier.isInvalid}
							errorMessage={validation.otherSupplier.message}
							onChange={this.onOtherSupplierChange}
							disabled={disabled || domain.readOnly} />
					</Grid>
					<Grid item xs={4}>
						<MaterialInputable
							required
							name={index + "_otherAccountNumber"} 
							label="Account"
							value={domain.otherAccountNumber} 
							error={validation.otherAccountNumber.isInvalid}
							errorMessage={validation.otherAccountNumber.message}
							onChange={this.onOtherAccountNumberChange}
							disabled={disabled || domain.readOnly} />
					</Grid>
					<Grid item xs={2}>
						{!(disabled || domain.readOnly) &&
						<Tooltip title="Delete">
							<IconButton aria-label="Delete" onClick={() => onRemove(index)} color="secondary" disabled={domain.readOnly}>
								<DeleteIcon />
							</IconButton>
						</Tooltip>
						}
						{process.env.NODE_ENV !== 'production' &&
						<IconButton aria-label="Validate" onClick={this.isValid} color="primary">
							<CheckCircleIcon />
						</IconButton>
						}
					</Grid>
				</Grid>
			</React.Fragment>
		)
	}
}

AccountNumbers.propTypes = {
	classes: PropTypes.object,
	index: PropTypes.number,
	disabled: PropTypes.bool,
	domain: PropTypes.object,
	onRemove: PropTypes.func,
	onChange: PropTypes.func,
	onChangeSelect: PropTypes.func,
	accountTypes: PropTypes.array,
}

AccountNumbers.defaultProps = {
	disabled: false
}

export default AccountNumbers



// WEBPACK FOOTER //
// ./src/components/AccountNumbers.js